export default {
  mounted(el, binding) {
    if (!Object.prototype.hasOwnProperty.call(binding, 'value') || binding.value) {
      el.focus();
    }
  },
};
